import React, { useEffect,useRef, useState } from 'react';
import { useGlobalContext } from '../../context';
import Book from "./Book";
import Journal from "./Journal";
import Article from "./Article";
import Author from "./Author";
import ArticleForm from './ArticleForm';
// import AuthorForm from './AuthorForm';
import CategoryForm  from './CategoryForm';
import Loading from "../Loader/Loader";
import BookForm from './BookForm';
import AuthorForm from './AuthorForm';
import { useParams } from 'react-router-dom';
import coverImg from "../../images/cover_not_found.jpg";
import "./BookList.css";
import { jwtDecode } from "jwt-decode";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { api } from '../../config';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Helmet } from 'react-helmet-async';

  // import Loader from "../Loader/Loader.jsx";
const BookList = () => {

  // Set loading state to true initially
  // Accessing global context for books data
  const {books, loading, resultTitle,searchCriteria,setSearchCriteria } = useGlobalContext();
  //console.log("searchCriteria",searchCriteria);
  const [showForm, setShowForm] = useState(false);
  const [categories, setCategories] = useState([]);
  const [showArticleForm, setShowArticleForm] = useState(false);
  const {searchTextShow}= useGlobalContext();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { id } = useParams();


  //useeffect when id changes set the criteria category id to id
    useEffect(() => {
    //  console.log("id", id);
      if (id !== 0) {

        getCategories();

        setSearchCriteria(prevCriteria => ({
          ...prevCriteria,
          category: id,
          type: searchCriteria.type,
          allFilter: "about",
        }));
      }
      //console.log("search criteria for id", searchCriteria);
    }, [id]);


  const checkTokenExpiration = () => {
    const token = localStorage.getItem('token');
    //console.log("token");
    //console.log(token);
    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
      //console.log("decodedToken");
      //console.log(decodedToken);
      if (decodedToken.exp < currentTime) {
        // Token has expired, clear it from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
      }
    }else{
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('username');
    }
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username); // Check if username exists in localStorage

  };

  useEffect(() => {
    const username = localStorage.getItem('username');

    // getCategories();
    setIsLoggedIn(!!username); // Check if username exists in localStorage
    checkTokenExpiration();
  }, []);

  const getCategories = async () => {
    try {
        const response = await fetch(`${api}/book_author/category/${id || ''}`, { method: 'GET' });
        const data = await response.json();
        setCategories(data);
    } catch (error) {
        console.error('Error fetching categories:', error);
    }
};



  const booksWithCovers = books.map((singleBook) => {
    return {
      ...singleBook,
      parentType:searchCriteria.type,
      id: (singleBook.book_id) ? (typeof singleBook.book_id === "number") ? singleBook.book_id : (singleBook.book_id).replace("/works/", "") : singleBook.book_id,
      cover_img: singleBook.cover_image ? singleBook.cover_image : coverImg
    }
  });
  const filteredBooks =   searchCriteria.allFilter !== "category" ? booksWithCovers.filter(book => {
    let filter = searchCriteria.allFilter;
    filter = searchCriteria.type === "book" ? "book" : filter;

    switch (filter) {
      case "journal":
        return book.order === 0;
      case "about":
        return false;
      case "article":
        return book.order != 0;
      case "book":
          return book.type =="book";
      case "author":
          return book.author_id;
      default:
        return true;
    }
  }) : categories.filter(book => {return book.category_id !== 0 })


  let titlePage= searchCriteria.type === "journal"  || searchCriteria.type === "article"? searchCriteria.categoryname:  searchCriteria.type  === "book" ?  resultTitle : searchCriteria.type  === "All"? 'الإصدارات الإلكترونية':'لاتوجد نتيجة';
  if(searchCriteria.isSearching === true &&searchTextShow&&searchCriteria.location !=="journal" &&searchCriteria.location !=="book" ){
    titlePage = 'بحث : " '+ searchTextShow +' "' ;
  }
  else if(searchCriteria.location === "main" && searchCriteria.isSearching == false){
    titlePage = 'المكتبة الرقمية';
  }else if(searchCriteria.allFilter === "about"||searchCriteria.allFilter === "journal"||searchCriteria.allFilter === "article"||(searchCriteria.type === "journal"  || searchCriteria.type === "article" || searchCriteria.type === "book") && searchCriteria.isSearching == false){
    if(searchCriteria.type === "journal"  || searchCriteria.type === "article"||searchCriteria.allFilter === "about"){

      categories.filter(category => category.category_id === Number(searchCriteria.category))
    .map((category) => (

      searchCriteria.allFilter === "about"||searchCriteria.allFilter === "journal"||searchCriteria.allFilter === "article" ? titlePage = category.category_name : titlePage = category.category_name)

    )

    }else{
    titlePage= searchCriteria.categoryname;
    }
  }else if(resultTitle && searchCriteria.isSearching == false && searchCriteria.location !== "book"){
    titlePage = "النتيجة";
  }else if(resultTitle && searchCriteria.isSearching == true ){
    titlePage = resultTitle;
  }else{
    titlePage = "";
  }

  const handleFilterChange = (event) => {
    const  value  = event;

    setSearchCriteria(prevCriteria => ({
      ...prevCriteria,

      type: value === "about" ? "": value === "category" ? "journal" : value,
      allFilter:value,
      category: searchCriteria.category === undefined ? "" : prevCriteria.category,

    }));
    }
    //tab title for main , book and journal pages
const Title = (titlePage === "المجلات العلمية المحكمة لمجمع الملك سلمان العالمي للغة العربية" ? "المجلات العلمية" :
              titlePage === "الكتب العلمية لمجمع الملك سلمان العالمي للغة العربية" ? "الكتب العلمية" :
              // searchCriteria.isSearching && searchCriteria.location === "main" ? "المكتبة الرقمية" :
              titlePage ) + " - مجمع الملك سلمان العالمي للغة العربية"

const Description  = titlePage === "المكتبة الرقمية" ?
  "المجلات الدورية والكتب الإلكترونية الصادرة عن مجمع الملك سلمان العالمي للغة العربية" :
  titlePage + " -  المكتبة الرقمية - مجمع الملك سلمان العالمي للغة العربية"

const Url = `https://library.ksaa.gov.sa/index${ 
  searchCriteria.location === "book" ? "/book" : 
  searchCriteria.location === "main" ?  "" :
  `/journal${searchCriteria.category == 0 ? "" : "/" + searchCriteria.category}`
}`

return (
  <>
    <Helmet>
      <title>
      {Title}
      </title>
      <meta
        name="description"
        content={Description}
      />
      <link
        rel="canonical"
        href={Url}
      />
    </Helmet>

    <section className='booklist'>

      <div className='container'>

      <ToastContainer />

      {loading ? (<Loading />):(
        <>

        <div className='section-title'>
          <h2 style={{textAlign:showForm?"right":"center"}}>{  showForm ? "إضافة كتاب / مجلة" :titlePage == "المكتبة الرقمية" ? "الإصدارات الإلكترونية" : titlePage}</h2>
          {searchCriteria.location === "book" && (
              <div className="m7-notice">
                <p> للمشاركة في المسار البحثي يمكن التواصل معنا عبر البريد التالي:
                <a href="mailto:nashr@ksaa.gov.sa" target='_blank' rel='noopener noreferrer'>nashr&#64;ksaa&#46;gov&#46;sa</a>
                </p>
              </div>
          )}
          {(!showForm && searchCriteria.location !== "book" && searchCriteria.category !== 0) && (
            <>


              <div className="journal-filters"  style={{textAlign:"center"}}>
                {/* abdullah was here */}

                <>

                {searchCriteria.allFilter === "journal" && searchCriteria.isSearching == false ?(
                <>
                <button className={`filter-btn  ${searchCriteria.allFilter === "about" ? "active-btn" : ""}`} onClick={() => handleFilterChange("about")}   >نبذة </button>
                <button className={`filter-btn  ${searchCriteria.allFilter === "journal" ? "active-btn" : ""}` }onClick={() => handleFilterChange("journal")} >الأعداد </button>
                <button className={`filter-btn  ${searchCriteria.allFilter == "article" ? "active-btn" : ""}`}onClick={() => handleFilterChange("article")} >البحوث  </button>

                </>
                ):(
                <>

                {searchCriteria.location !== "main" ? (
                <>
                 <button className={`filter-btn  ${searchCriteria.allFilter === "about" ? "active-btn" : ""}`} onClick={() => handleFilterChange("about")} >نبذة </button>
                <button className={`filter-btn  ${searchCriteria.allFilter === "journal" ? "active-btn" : ""}` } onClick={() => handleFilterChange("journal")}  >الأعداد </button>
                <button className={`filter-btn  ${searchCriteria.allFilter == "article" ? "active-btn" : ""}`} onClick={() => handleFilterChange("article")}>البحوث  </button>
                </>
                ):(
                  searchCriteria.isSearching === false ? (
                 <>
                <button className={`filter-btn  ${searchCriteria.allFilter === "category" ? "active-btn" : ""}` }   onClick={() => handleFilterChange("category")}  >المجلات</button>

                <button className={`filter-btn  ${searchCriteria.allFilter == "book" ? "active-btn" : ""}`} onClick={() => handleFilterChange("book")}> الكتب </button>
                </>
                ):(
                <>
                <button className={`filter-btn  ${searchCriteria.allFilter == "book" ? "active-btn" : ""}`} onClick={() => handleFilterChange("book")}> الكتب </button>
                <button className={`filter-btn  ${searchCriteria.allFilter === "journal" ? "active-btn" : ""}`} onClick={() => handleFilterChange("journal") }  >الأعداد </button>
                <button className={`filter-btn  ${searchCriteria.allFilter == "article" ? "active-btn" : ""}` } onClick={() => handleFilterChange("article")} >البحوث  </button>
                <button className={`filter-btn  ${searchCriteria.allFilter === "author" ? "active-btn" : ""}` } onClick={() => handleFilterChange("author")} >المؤلفين </button>
                </>
                )
               )}
                </>
              )}
               </>

              </div>

            </>
            )}

        </div>
        {isLoggedIn &&  (
          <>
           <BookForm />
           {/* <AuthorForm /> */}
           {searchCriteria.allFilter !== 'article'&& (<ArticleForm />)}
           <AuthorForm />
           <CategoryForm />
           </>
        )}
          <div className={`booklist-content ${searchCriteria.type === "article" && searchCriteria.category !== undefined  ? "" :filteredBooks.length == 0 ? "": "grid"}`} style={{ gridTemplateColumns: (searchCriteria.allFilter === "article" || searchCriteria.allFilter === "author") ? "auto" : "" }}>
              {searchCriteria.allFilter === "article" || searchCriteria.allFilter === "author" ? (
                  // Make sure the filtered books are articles or authors

                  searchCriteria.allFilter === "article" ? (
                    filteredBooks.length > 0 ? ( <Article article={filteredBooks} />
                  ) : (
                    <h1 style={{textAlign:"center"}}> لاتوجد نتيجة  </h1 >
                )
                  ) : (
                    filteredBooks.length > 0 ? (

                      <Author author={filteredBooks} />
                    ) : (
                      <h1 style={{textAlign:"center"}}> لاتوجد نتيجة  </h1 >
                  )
                  )

              ) : (
                filteredBooks.length > 0  || searchCriteria.allFilter == "about"? (
                  filteredBooks.map((item, index) => {
                      return searchCriteria.allFilter !== "category" ? (
                          <Book key={item.book_id} {...item} />
                      ) : (
                          <Journal key={item.book_id} {...item} />
                      );
                  })
              ) : (

                <h1 style={{textAlign:"center"}}> لاتوجد نتيجة  </h1 >
              )
              )}
          </div>
        </>
      )}
      </div>
      <div>

      {searchCriteria.category && searchCriteria.category !== 0 && (
  categories.filter(category => category.category_id === Number(searchCriteria.category))
    .map((category) => (

      searchCriteria.allFilter === "about" && (

        <div key={category.category_id} className='book-details-form' style={{maxWidth:"1150px"}} >
         <ReactQuill

         value={ category.description}
         readOnly={true}  // Set ReactQuill to read-only mode
         modules={{ toolbar: false }}  // Optionally disable the toolbar when read-only

       />
       </div>

      )


    ))
)}

    </div>

    </section>
  </>
  )
}

export default BookList;
